import useSWR from "swr";
import API from "../../../utils/api";
import { EXCHANGESETTINGS } from "../../constants/APIKEYS";

// ep_id별로 데이터를 캐시하는 Map 사용
const swrDataCache = new Map<number, any>();

export function useExchangeSetting(ep_id: number) {
	// 각 ep_id에 대해 고유한 키 생성
	const KEY = ep_id ? `${EXCHANGESETTINGS}/${ep_id}` : null;

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if (swrDataCache.has(ep_id)) {
				return swrDataCache.get(ep_id);
			}

			const response = await API.get(KEY + '', '', {}, false)
			const result = response.result;
			swrDataCache.set(ep_id, result);
			return result;
		},
		{ revalidateOnFocus: true, dedupingInterval: 0 }
	)

	return {
		data,
		mutate: (value: any) => {
			if (value !== undefined) {
				swrDataCache.set(ep_id, value);
			}
			return mutate()
		},
		getData: (epid?: number) => {
			const targetEpId = epid || ep_id;

			if (!swrDataCache.has(targetEpId)) {
				// 데이터가 없으면 mutate 호출하여 데이터 로드
				mutate();
			}

			try {
				return swrDataCache.get(targetEpId) || null;
			} catch (e) {
				return null;
			}
		},
	}
}
